// import Vue from 'vue'
// import Vuex from 'vuex'
// const Vue = require('vue')
// const Vuex = require('vuex')
// Vue.use(Vuex)
import u8sdk from './modules/u8sdk';
export default new Vuex.Store({
  modules: {
    u8sdk: u8sdk
  }
});